export default "__VITE_ASSET__DVxghncR__"